export const icebreakerTasks = [
  {
    name: "Start your own project! 🚀",
    date: "",
    projectId: "welcome",
    taskId: "icebreaker_1",
    boardStatus: "TODO",
    completed: false,
  },
  {
    name: "Schedule tasks 📅 ",
    date: "",
    projectId: "welcome",
    taskId: "icebreaker_2",
    boardStatus: "TODO",
    completed: false,
  },
  {
    name: "Get organized anywhere!",
    date: "",
    projectId: "welcome",
    taskId: "icebreaker_3",
    boardStatus: "TODO",
    completed: false,
  },
  {
    name: "View projects as lists or boards",
    date: "",
    projectId: "welcome",
    taskId: "icebreaker_4",
    boardStatus: "TODO",
    completed: false,
  },
];
